module.exports = __webpack_public_path__ + "static/media/big-deal-50T-background.7aed1507.jpg";